






























































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import AiAdviceDetailApi from '@/app/model/api/aiAdviceDetailApi'
import AiAdviceCreateApi from '@/app/model/api/aiAdviceCreateApi'
import AiAdviceEditApi from '@/app/model/api/aiAdviceEditApi'
import AiAdviceDeleteApi from '@/app/model/api/aiAdviceDeleteApi'
/* quill */
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import Local from '@/app/module/local'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo,
    quillEditor
  }
})
export default class AiAdviceCreate extends Vue {
  private aiAdviceId: string = ''
  private aiAdviceData: any = {}
  private aiAdviceName: string = ''
  private constantValue: any = []

  private aiAdvicePlans: any = [{
    name: '潅水管理作業'
  },
  {
    name: '観察・管理作業'
  },
  {
    name: '施肥'
  },
  {
    name: '農薬・害虫対策'
  }]

  private aiAdvicePlanContent: any = []
  private aiAdviceStages: any = []

  private remarks: string = ''
  private timeStamp: number = 0
  private errorMessages: Array<string> = []
  private alertText: string = ''
  private alertTitle: string = ''
  private isError: any = {}
  /* 表示非表示 */
  private showLoading: boolean = true
  private editflag: boolean = false
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  private isFocusKey: string = ''
  private editorOption: any = {
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold'],
        [{ 'color': [] }],
        ['link']
      ]
    },
    placeholder: '',
    theme: 'snow'
  }
  private lastStageKey: number = 9

  private onFocus (key: string) {
    this.isFocusKey = key
  }

  created () {
    this.aiAdviceId = this.$route.params.ai_advice_id
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.setAiAdviceTextAreas(this.constantValue.sys_variety_stages)
    this.getAiAdvice()
  }

  mounted () {
    document.addEventListener('click', (e: any) => {
      // AIアドバイスの入力範囲外を押下したらツールチップは非表示にする
      if (!e.target.closest('.list-detail')) {
        this.isFocusKey = ''
      }
    })
  }

  destroyed () {
    for (let i in this.errorMessages) {
      this.errorMessages[i] = ''
    }
  }

  private scrollToStart () {
    let target: any = document.getElementById('listTable')
    target.scrollLeft = 0
  }

  private countStringHtmlExcept (data: string) {
    let test = data.replace(/(<([^>]+)>)/gi, '')
    return test.length
  }

  private setAiAdviceTextAreas (sysStage: any) {
    sysStage.forEach((element: any) => {
      const content = {
        'variety_stage_step': element.sys_variety_stage_id,
        'watering': '',
        'observation': '',
        'fertilization': '',
        'risk': ''
      }
      this.aiAdvicePlanContent.push(content)
      const stage = {
        'name': element.variety_stage_name,
        'variety_stage_step': element.sys_variety_stage_id
      }
      this.aiAdviceStages.push(stage)
    })
  }

  private getAiAdvice () {
    (async () => {
      const routePath = this.$route.path
      if (routePath !== '/master/ai-advice/create') {
        this.editflag = true
      }

      if (this.editflag) {
        const result = await AiAdviceDetailApi.getAiAdviceDetail(this.aiAdviceId)
        if (result.isOk()) {
          this.aiAdviceData = result.getPayload()

          this.aiAdviceName = this.aiAdviceData.ai_advice_name
          this.aiAdvicePlanContent = this.aiAdviceData.ai_advice_plans
          if (this.aiAdviceStages.length !== this.aiAdvicePlanContent.length) {
            // 一致していないならば、足りないvariety_stage_step分だけ追加する
            const notEnoughData = []
            for (let i = 0; i < this.aiAdviceStages.length; i++) {
              let isCheck = false
              for (let j = 0; j < this.aiAdvicePlanContent.length; j++) {
                if (this.aiAdviceStages[i].variety_stage_step === this.aiAdvicePlanContent[j].variety_stage_step) {
                  isCheck = true
                  break
                }
              }
              if (!isCheck) {
                const data = {
                  'variety_stage_step': this.aiAdviceStages[i].variety_stage_step,
                  'watering': '',
                  'observation': '',
                  'fertilization': '',
                  'risk': ''
                }
                notEnoughData.push(data)
              }
            }
            if (notEnoughData.length > 0) {
              const sortTarget = this.aiAdvicePlanContent.concat(notEnoughData)
              this.aiAdvicePlanContent = sortTarget.sort((element1 : any, element2 : any) => {
                return (element1.variety_stage_step < element2.variety_stage_step) ? -1 : 1
              })
            }
          }
          this.timeStamp = this.aiAdviceData.time_stamp
          this.remarks = this.aiAdviceData.remarks
          this.showLoading = false
          setTimeout(this.scrollToStart, 10)
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      } else {
        this.showLoading = false
      }
    })()
  }

  private aiAdviceSave () {
    if (this.editflag) {
      this.aiAdviceEdit()
    } else {
      this.aiAdviceCreate()
    }
  }

  private async aiAdviceEdit () {
    if (!this.isAiAdviceEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }
    this.showLoading = true

    const bodyData: any = {
      ai_advice_name: this.aiAdviceName,
      remarks: this.remarks,
      ai_advice_plans: this.aiAdvicePlanContent,
      time_stamp: this.timeStamp
    }

    const result = await AiAdviceEditApi.doAiAdviceEdit(this.aiAdviceId, bodyData)
    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'AIアドバイス編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/ai-advice').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async aiAdviceCreate () {
    /* バリデーションチェック */
    if (!this.isAiAdviceEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }
    this.showLoading = true

    const bodyData: any = {
      ai_advice_name: this.aiAdviceName,
      remarks: this.remarks,
      ai_advice_plans: this.aiAdvicePlanContent
    }

    const result = await AiAdviceCreateApi.doAiAdviceCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'AIアドバイス追加が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/ai-advice').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  /* バリデーション */
  private isAiAdviceEdit () {
    // リセット
    this.errorMessages = []

    const aiAdviceNameFlag = Validator.validateInputAiAdviceName('aiAdviceNameErrorMessage', this.aiAdviceName)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true
    if (this.aiAdviceName && [...this.aiAdviceName].length > 100) {
      isError = false
      this.$set(this.errorMessages, 'aiAdviceNameErrorMessage', 'AIアドバイス名は100文字以下で入力してください。')
    }
    if (this.remarks && [...this.remarks].length > 500) {
      isError = false
      this.$set(this.errorMessages, 'aiAdviceRemarksErrorMessage', '備考は500文字以下で入力してください。')
    }
    for (let i in this.aiAdvicePlanContent) {
      const data = this.aiAdvicePlanContent[i]
      // 潅水管理作業
      if (data.watering !== null && data.watering !== undefined) {
        if (this.countStringHtmlExcept(data.watering) > 500) {
          this.$set(this.errorMessages, 'watering', '潅水管理作業は500文字以下で入力してください。')
          isError = false
          this.$set(this.isError, 'watering' + i, true)
        } else {
          this.$set(this.isError, 'watering' + i, false)
        }
      }
      // 観察・管理作業
      if (data.observation !== null && data.observation !== undefined) {
        if (this.countStringHtmlExcept(data.observation) > 500) {
          this.$set(this.errorMessages, 'observation', '観察・管理作業は500文字以下で入力してください。')
          isError = false
          this.$set(this.isError, 'observation' + i, true)
        } else {
          this.$set(this.isError, 'observation' + i, false)
        }
      }
      // 施肥
      if (data.fertilization !== null && data.fertilization !== undefined) {
        if (this.countStringHtmlExcept(data.fertilization) > 500) {
          this.$set(this.errorMessages, 'fertilization', '施肥は500文字以下で入力してください。')
          isError = false
          this.$set(this.isError, 'fertilization' + i, true)
        } else {
          this.$set(this.isError, 'fertilization' + i, false)
        }
      }
      // 農薬・害虫対策
      if (data.risk !== null && data.risk !== undefined) {
        if (this.countStringHtmlExcept(data.risk) > 500) {
          this.$set(this.errorMessages, 'risk', '農薬・害虫対策は500文字以下で入力してください。')
          isError = false
          this.$set(this.isError, 'risk' + i, true)
        } else {
          this.$set(this.isError, 'risk' + i, false)
        }
      }
    }

    return aiAdviceNameFlag && isError
  }

  /* Aiアドバイス削除 */
  private doAiAdviceDelete () {
    (async () => {
      this.showLoading = true
      const result = await AiAdviceDeleteApi.doAiAdviceDelete(this.aiAdviceId.toString())
      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'AIアドバイスを削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/ai-advice').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
      this.showLoading = false
    })()
  }

  private doCancel () {
    this.$router.push('/master/ai-advice').catch(e => {})
  }
}
